<div>
  <div class="mat-h3">
    CSV-Kopfzeilen
  </div>
  <p>
    Hier legen Sie fest, wie die Kopfzeilen in der CSV-Datei benannt sind. Falls Ihre CSV-Datei keine Kopfzeilen enthält,
    geben Sie bitte den entsprechenden Spaltenindex für die benötigten Kategorien an.
  </p>
  <ul>
    <li>
      <div class="mat-h3">
        Rechnungsnummer
      </div>
      <p>
        Geben Sie die Kopfzeile oder den Spaltenindex für die Rechnungsnummer an.
        Die Rechnungsnummer wird benötigt.
      </p>
    </li>
    <li>
      <div class="mat-h3">
        Datum
      </div>
      <p>
        Geben Sie die Kopfzeile oder den Spaltenindex für das Datum des Zahlungseingangs an.      </p>
    </li>
    <li>
      <div class="mat-h3">
        Saldo
      </div>
      <p>
        Hier können Sie die Kopfzeile oder den Spaltenindex für den Saldo angeben.
        Es ist erforderlich, entweder eine Saldo-Spalte oder zwei separate Spalten
        für Soll und Haben anzugeben.
      </p>
    </li>
    <li>
      <div class="mat-h3">
        Soll
      </div>
      <p>
        Geben Sie die Kopfzeile oder den Spaltenindex für das Soll an. Es ist erforderlich,
        entweder eine Saldo-Spalte oder zwei separate Spalten für Soll und Haben anzugeben.
      </p>
    </li>
    <li>
      <div class="mat-h3">
        Haben
      </div>
      <p>
        Geben Sie die Kopfzeile oder den Spaltenindex für das Haben an. Es ist erforderlich, entweder eine Saldo-Spalte
        oder zwei separate Spalten für Soll und Haben anzugeben.
      </p>
    </li>
    <li>
      <div class="mat-h3">
        Soll-Haben-Kenner
      </div>
      <p>
        Geben Sie die Kopfzeile oder den Spaltenindex für den Soll-Haben-Kenner an.      </p>
    </li>
  </ul>
</div>
